import { Activity, Database, FileText, History, RefreshCw, Search, TrendingUp } from "lucide-react";
import { freshnessLabel, marketFreshnessLabel, marketFreshnessTone } from "../lib/format";
import type { MarketFreshness } from "../lib/types";

export function Sidebar({ latestDate }: { latestDate: string | null }) {
  const items = [
    ["Market Pulse", "#market-pulse", Activity],
    ["Symbols", "#symbols", Search],
    ["Minute Replay", "#minute-replay", History],
    ["Scanners", "#scanners", TrendingUp],
    ["Reports", "#reports", FileText],
    ["Pipeline", "#pipeline", Database]
  ] as const;
  return (
    <aside className="sidebar">
      <div className="brand-mark">KZG</div>
      <nav>
        {items.map(([label, href, Icon], index) => (
          <a key={label} className={index === 0 ? "nav-item active" : "nav-item"} href={href} title={label}>
            <Icon size={21} />
            <span>{label}</span>
          </a>
        ))}
      </nav>
      <div className="connection">
        <span className="dot" />
        <strong>Market Data</strong>
        <em>Connected</em>
      </div>
      <div className="clock">
        <span>NYSE</span>
        <strong>{latestDate ?? "unbuilt"}</strong>
      </div>
    </aside>
  );
}

export function Topbar({
  latestDate,
  generatedAt,
  coverage,
  freshness,
  searchValue,
  suggestions,
  directoryCount,
  onSearchChange,
  onRefresh
}: {
  latestDate: string | null;
  generatedAt: string | null;
  coverage: string;
  freshness?: MarketFreshness;
  searchValue: string;
  suggestions: string[];
  directoryCount: number;
  onSearchChange: (value: string) => void;
  onRefresh: () => void;
}) {
  return (
    <header className="topbar">
      <div className="title-block">
        <strong>KZG Stock House</strong>
      </div>
      <div className="status-block">
        <span>Latest Trading Day</span>
        <strong>{latestDate ?? "Run data build"}</strong>
      </div>
      <div className="status-block">
        <span>Data Freshness</span>
        <strong className={marketFreshnessTone(freshness)}>{marketFreshnessLabel(freshness)}</strong>
      </div>
      <div className="status-block wide">
        <span>Build Age / Coverage</span>
        <strong className={coverage === "minute_only" ? "warn" : "up"}>
          {freshnessLabel(generatedAt)} / {coverage === "minute_only" ? "Minute-only" : "Full"}
        </strong>
      </div>
      <label className="search-box">
        <Search size={18} />
        <input
          list="symbol-suggestions"
          placeholder="Search symbol (e.g., NVDA)"
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value.toUpperCase())}
        />
        <datalist id="symbol-suggestions">
          {suggestions.map((symbol) => (
            <option key={symbol} value={symbol} />
          ))}
        </datalist>
        <kbd title={`${directoryCount.toLocaleString("en-US")} searchable symbols`}>
          {directoryCount ? `${(directoryCount / 1000).toFixed(1)}K` : "/"}
        </kbd>
      </label>
      <button className="refresh-button" onClick={onRefresh}>
        <RefreshCw size={17} />
        Refresh
      </button>
    </header>
  );
}
